// const CLIENT_ID = '0oa9qtmg4zvW3NMwm5d7';
// const ISSUER = 'https://dev-73768694.okta.com/oauth2/default';
// const REDIRECT_URI = `http://localhost:3000/login/callback`;

const CLIENT_ID = "0oaak9gljgyulm04F0i7";
const ISSUER = "https://intlsos.okta-emea.com/oauth2/default";
const REDIRECT_URI = `https://dbcdev.internationalsos.com/login/callback`;

const OKTA_TESTING_DISABLEHTTPSCHECK =
  process.env.OKTA_TESTING_DISABLEHTTPSCHECK || false;

// eslint-disable-next-line
export default {
  oidc: {
    clientId: CLIENT_ID,
    issuer: ISSUER,
    redirectUri: REDIRECT_URI,
    scopes: ["openid", "profile", "email", "cards"],
    responseType: ["token", "id_token", "code"],
    pkce: true,
    disableHttpsCheck: OKTA_TESTING_DISABLEHTTPSCHECK,
  },
  resourceServer: {
    messagesUrl: "http://localhost:3000/api/messages",
  },
  REST_API_CTX: {
    PROTOCOL: "https://",
    HOST: "dbcdev.internationalsos.com",
    PORT: "",
    POSTFIX: "/api",
  },
};
